import { render, staticRenderFns } from "./TercihlerView.vue?vue&type=template&id=76a86b4b"
import script from "./TercihlerView.vue?vue&type=script&lang=ts"
export * from "./TercihlerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports